// vue
import { watch, computed, PropType } from 'vue';

// types
import type { Props, Context } from '../types';

// i18n
import { useI18n } from 'vue-i18n';

// store
import { useRbResetFixOrder } from '../store';
import { useStats } from '@store/stats';
import { useGl } from '@store/gl';
import { useRefs } from '@store/ts/refs';

// router
import { useRoute } from 'vue-router';

export const generalProps = {
    text: { type: String as PropType<Props['text']>, required: false },
};

export const shared = (_props: Readonly<Props>, _context: Context) => {
    const { t } = useI18n();

    // store
    const gl = useGl();
    const stats = useStats();
    const refs = useRefs();
    const rbResetFixOrder = useRbResetFixOrder();

    // router
    const route = useRoute();

    watch(() => route.name, () => {
        rbResetFixOrder.showModal = false;
    });

    const buttonDisabled = computed(() => rbResetFixOrder.bots.every(el => el.status));

    const allBotsError = computed(() => rbResetFixOrder.bots.every(el => !el.status && el.messages.length));
    const someBotsError = computed(() => rbResetFixOrder.bots.some(el => !el.status && el.messages.length));
    const allBotsSuccess = computed(() => rbResetFixOrder.bots.every(el => el.status && el.messages.length));

    return {
        t,
        gl,
        stats,
        refs,
        rbResetFixOrder,
        buttonDisabled,
        allBotsError,
        someBotsError,
        allBotsSuccess,
    };
};